import type { PropsWithChildren } from 'react';
import type React from 'react';
import { useContext } from 'react';

import { PageScrollPositionContext } from './context';
import type { PageScrollPosition } from './context';
import { usePageScrollPositionState } from './pageScrollPositionState';

export type { PageScrollPosition } from './context';

export function usePageScrollPosition(): PageScrollPosition {
	const context = useContext(PageScrollPositionContext);

	if (!context) {
		throw new Error('PageScrollPositionContext was not set');
	}

	return context;
}

export const PageScrollPositionProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const info = usePageScrollPositionState();

	return <PageScrollPositionContext.Provider value={info}>{children}</PageScrollPositionContext.Provider>;
};
